module.exports = __webpack_public_path__ + "img/선릉역 미용실 1.d7b748d1.png";